@if (this.showIcon) {
  <div id="button" (click)="disabled() ? closeChat() : openChat()">
    <mat-icon>forum</mat-icon>
  </div>
}
